/**
 * @file: config 读写封装，config的读写一定要通过config的get方法，禁止直接从config读写
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';
import sketchpad from './sketchpad';
import select from './select';
import shelf from './shelf';
import layer from './layer';
import goods from './goods';
import freezer from './freezer';
import base from './base';
import transform from './transform';
import fundebug from './fundebug';
import imgIcon from './imgIcon';

let Config: ConfigMap = {
    // 基础配置
    base: Utils.deepCopy(base),

    // sketchpad相关配置
    sketchpad: Utils.deepCopy(sketchpad),

    // 选择器相关配置
    select: Utils.deepCopy(select),

    // 货架相关配置
    shelf: Utils.deepCopy(shelf),

    // 画布缩放、移动相关配置
    transform: Utils.deepCopy(transform),

    // 层板相关配置
    layer: Utils.deepCopy(layer),

    // 商品相关配置
    goods: Utils.deepCopy(goods),

    // 卧柜相关配置
    freezer: Utils.deepCopy(freezer),

    // fundebug
    fundebug: Utils.deepCopy(fundebug),

    // 图标
    imgIcon: Utils.deepCopy(imgIcon)
};

// config get方法
function get(params: ConfigGetParams): any {
    const { moduleName, key } = params;

    // config中配置类型不存在
    if (typeof Config[moduleName] === 'undefined') {
        return undefined;
    }

    return Utils.getMapValueByStringKey(Config[moduleName], key);
}

// config set方法
function set(params: ConfigSetParams): undefined|boolean {
    const { moduleName, key, value } = params;

    if (typeof Config[moduleName] === 'undefined') {
        return undefined;
    }
    let oldValue: any = Utils.getMapValueByStringKey(Config[moduleName], key);

    /**
     * 如果操作key不存在，放弃设置操作，对key设值，必须要在config中提前申明该key，不允许对config做副作用操作
     * 避免config信息无法追踪，失控
     */
    if (typeof oldValue === 'undefined') {
        return undefined;
    }
    Utils.setMapValueByStringKey(Config[moduleName], key, value);
    return true;
}

// 从外部config中获取配置信息
function getGlobalConfig(key: string): any {
    return globalConfig[key];
}

// 设置外部config
function setGlobalConfig(key: string, value: any): any {
    return globalConfig[key] = value;
}

// 重置所有配置到初始状态
function reset(): void {
    Config.base = Utils.deepCopy(base);
    Config.sketchpad = Utils.deepCopy(sketchpad);
    Config.select = Utils.deepCopy(select);
    Config.shelf = Utils.deepCopy(shelf);
    Config.transform = Utils.deepCopy(transform);
    Config.layer = Utils.deepCopy(layer);
    Config.goods = Utils.deepCopy(goods);
    Config.freezer = Utils.deepCopy(freezer);
}

export default {
    get,
    set,
    reset,
    getGlobalConfig,
    setGlobalConfig
}
